export enum Theme {

  DEFAULT = 'DEFAULT',
  DARK = 'DARK',
  LIGHT = 'LIGHT'

}
